<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h1"
            :title="$t('business.goals.title')"
        )



        v-container(fluid grid-list-lg)
            v-layout(raw wrap)
                v-flex(xs12).mt-3

                    consecutive-form

                    div.mt-3
                        daily-activity

                    // Horizontal line
                    separator-component

                    div.controls
                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="primary"
                                large
                            ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Layout from '../../Layout/Layout';
    import ConsecutiveDaysForm from './ConsecutiveDaysForm';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';
    import VueTypes from 'vue-types';
    import DailyActivity from './DailyActivity';

    export default {
        components: {
            Layout,
            DailyActivity,
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            ConsecutiveForm: ConsecutiveDaysForm
        },
        props: {
            id: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('goals', ['isLoading'])
        },
        created() {
            this.readGoals(this.id);
        },
        methods: {
            ...mapActions('goals', ['createGoals', 'readGoals', 'cancel']),

            /**
             * Create Goals for Business account on submit
             * @returns {boolean}
             */
            async submit() {
                this.createGoals(this.id);
            }
        }
    };
</script>
